import { Routes } from "./routes";
import Toast from "./components/Toast";

import { AuthProvider } from "./contexts/AuthContext";
import { ThemeContextProvider } from "./contexts/ThemeContext";
import { CountryProvider } from "./contexts/CountryContext";
import { IntlContextProvider } from "./contexts/IntlContext";

function App() {
  return (
    <>
      <AuthProvider>
        <ThemeContextProvider>
        <Toast />
          <CountryProvider>
            <IntlContextProvider>
              <Routes />
            </IntlContextProvider>
          </CountryProvider>
        </ThemeContextProvider>
      </AuthProvider>
    </>
  );
}

export default App;
